const initialState = {
 	datos: {},
 	loading: true,
 	error: null,
 	status: null,
 	filters:{
	  	date:{
	  		fechaStartFinal: null,
	  		fechaEndFinal: null
	  	},
  		tags:[],
  		vehicleType: null,
  		direction: null,
  		status: null
  	}
};

 export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/flow_admin_rca_reports/initialState.js